export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./bot.vue?vue&type=template&id=22a17d2e"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/view/bot.vue?vue&type=template&id=22a17d2e
// module id = MU5+
// module chunks = 0